module.exports = __webpack_public_path__ + "static/media/typescript.5c663c66052aeea0a9e626029851efa4.svg";